export interface Device {
  label: string;
  deviceId: string;
}

export const defaultDevice = {
  label: '',
  deviceId: '',
};
